import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class LegacyCompositionService extends RestfulService<Models.LegacyComposition> {

  constructor(private restService: RestService) {
    super(Models.LegacyComposition);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('legacy-compositions');
  }

}
